module.exports = __webpack_public_path__ + "img/logo-openid.923005df.png";